import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store";
import AllCampaignIcon from "../../../assets/img/icons/Campaign/AllCampaign.svg";
import {
  reorderCampaignsAndEmails,
  resetSelectedCampaigns,
  searchAnalyticsDropdownCampaigns,
  selectCampaign,
  setCampaignsFilter,
  setShareProfileFilter,
} from "../Dashboard/actions";
import { ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS } from "constants/types";
import { ICampaignDropdownItem } from "../interfaces";
import SelectFilterWithIcon from "./SelectFilterWithIcon";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";

interface ICampaignFiltersDropdown {
  dropdownClass?: string;
  closeDropDownHandler: () => void;
}

const CampaignFiltersDropdown: React.FC<ICampaignFiltersDropdown> = (props) => {
  const dispatch = useDispatch();
  const { dropdownClass, closeDropDownHandler } = props;
  const campaigns = useSelector((state: RootState) => state.analyticsDashboard.campaigns);
  const filteredCampaigns = useSelector((state: RootState) => state.analyticsDashboard.filteredCampaigns);
  const isCampaignSearch = useSelector((state: RootState) => state.analyticsDashboard.isCampaignSearch);
  const searchedCampaigns = useSelector((state: RootState) => state.analyticsDashboard.searchedCampaigns);
  const selectedCampaignsIds = useSelector((state: RootState) => state.analyticsDashboard.selectedCampaignsIds);
  const campaignsFilters = useSelector((state: RootState) => state.analyticsDashboard.campaignsFilters);
  const { isShareProfile, isDailyIQ, isWeeklyAccountInsights } = useSelector(
    (state: RootState) => state.analyticsDashboard
  );
  const campaignsLimitReached = useSelector((state: RootState) => state.analyticsDashboard.campaignsLimitReached);
  const hasShareProfilePermission = useSelector((state: RootState) => state.user.has_share_profile_perm);
  const hasDailyIqPermission = useSelector((state: RootState) => state.user.has_daily_iq_perm);
  const hasWeeklyAccountInsightsPermission = useSelector(
    (state: RootState) => state.user.has_weekly_account_insight_perm
  );
  const firstAllDataShown = useSelector((state: RootState) => state.analyticsDashboard.firstAllDataShown);
  const xiqInternalUser = useSelector((state: RootState) => state.user.xiq_internal_user);
  const defaultCampaigns = useSelector((state: RootState) => state.analyticsGraph.data?.campaigns_series);
  // const AllCampaignsFilterCheck = useSelector(
  //   (state: RootState) => state.analyticsDashboard.campaignsFilters.isAllCampaigns
  // );
  const isDefaultDataSet = useSelector((state: RootState) => state.analyticsDashboard.isDefaultDataSet);
  const campaignsLoading = useSelector((state: RootState) => state.analyticsDashboard.campaignsAssetsLoading);

  useEffect(() => {
    return () => {
      resetSelectedCampaigns(true);
      searchAnalyticsDropdownCampaigns("");
    };
  }, []);

  useEffect(() => {
    // hook to handle the default state of select/unselect
    if (campaigns.length && defaultCampaigns?.length && !isDefaultDataSet) {
      dispatchActionToSetDefault();
    }
  }, [defaultCampaigns, campaigns]);

  function dispatchActionToSetDefault() {
    const campaignId = getQueryCampaignId();
    dispatch({
      type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.SET_DEFAULT,
      payload: {
        campaignIds: campaignId ? [campaignId] : defaultCampaigns?.map((campaign) => campaign.campaign_id),
        emailId: getQueryEmailId(),
      },
    });
  }

  return (
    <SelectFilterWithIcon
      label={selectedCampaignsIds.length > 0 ? `${selectedCampaignsIds.length} Campaign(s) selected` : "Campaigns"}
      icon={AllCampaignIcon}
      searchTitle="Search campaigns…"
      filterTitle="Filter Campaign"
      idPrefix="campaigns-01"
      items={isCampaignSearch ? searchedCampaigns : filteredCampaigns.length > 0 ? filteredCampaigns : campaigns}
      onSearchInput={(value: any) => {
        searchAnalyticsDropdownCampaigns(value);
      }}
      filters={campaignsFilters}
      setCheckBox={(value: boolean) => setCampaignsFilter(value)}
      setShareProfileFilter={(value: boolean) => setShareProfileFilter(value)}
      setSelected={(value: ICampaignDropdownItem) => selectCampaign(value.id, selectedCampaignsIds)}
      selectedItems={selectedCampaignsIds}
      // campaignSelectedMessage={selectedCampaignsIds.length === 4 ? "Max. 4 campaigns selected!" : ""}
      campaignSelectedMessage={campaignsLimitReached}
      isAsset={false}
      dropdownClass={`${dropdownClass} dropdown-menu-wrapper-v2`}
      onClose={() => {
        reorderCampaignsAndEmails();
        closeDropDownHandler();
      }}
      isShareProfile={isShareProfile}
      isDailyIQ={isDailyIQ}
      hideDailyIQ={!hasDailyIqPermission}
      isWeeklyAccountInsights={isWeeklyAccountInsights}
      hideWeeklyAccountInsights={!hasWeeklyAccountInsightsPermission}
      hideShareProfile={!hasShareProfilePermission}
      disableDropdown={!firstAllDataShown}
      loading={campaignsLoading}
      // disableSearch={campaignsFilters.isAllCampaigns}
    />
  );
};

export default React.memo(CampaignFiltersDropdown);
